import React, { useState, useEffect, useRef } from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Status from "components/presentation/Status";
import {
    faCheck
} from "@fortawesome/free-solid-svg-icons";
import { usePrevious } from "./common"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function CompetitorBlock(competitor) {
    //console.log(competitor)
    let seed = ''
    let competitorBracket;
    if (competitor.co_seed) {
        seed = '(' + competitor.co_seed + ')'
    }
    if (competitor?.participant?.__typename === 'Person') {
        competitorBracket = <div className="w-85"><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} /></div>
    } else {
        competitorBracket = <div className="w-85"><Competitor hidePicture={true} hideNoc={true} noLink={true} teamAthletes={competitor?.resultItem?.teamAthletes} /></div>
    }

    //Check if the game is singles or doubles

    return (
        <div className='score-competitor-container d-flex justify-content-start text-truncate'>
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center'>
                {competitorBracket}
                <span><sup>{seed}</sup></span>
            </div>
        </div>
    )
}

export function Footer({ data }) {
    const formatDate = Label({ data: 'BracketDateFormat' });
    const formatDateTime = Label({ data: 'BracketDateTimeFormat' });

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} /></>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date

    //console.log(data)
    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code) && <div className='row'><div className='text-start col'>{dateComponent}</div><div className='text-end col'>{data?.schedule?.location?.shortDescription}</div></div>}
        </>
    )
}